import React from 'react'
import GoogleSheets from '../../../../../components/GoogleSheets/GoogleSheets'

const ExternalGoogleSheets = () => {
  return <GoogleSheets type="external" />
}

export default ExternalGoogleSheets
